export const InterTightWeight = {
  Thin: "100",
  ExtraLight: "200",
  Light: "300",
  Regular: "400",
  Medium: "500",
  SemiBold: "600",
  Bold: "700",
  ExtraBold: "800",
  Black: "900",
} as const;

export type InterTightWeightName = keyof typeof InterTightWeight;
